import { render, staticRenderFns } from "./barcode-editor.vue?vue&type=template&id=317db718&scoped=true"
import script from "./barcode-editor.vue?vue&type=script&lang=js"
export * from "./barcode-editor.vue?vue&type=script&lang=js"
import style0 from "./barcode-editor.vue?vue&type=style&index=0&id=317db718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317db718",
  null
  
)

export default component.exports